// Merges two independently-sampled time series onto one shared timeline for
// a single chart, rather than two separate charts that merely share a
// syncId (Recharts' syncId only synchronizes tooltip/brush interaction, it
// does not combine data - see the Experiment page's chart, which needs both
// series' values overlaid on one X axis for real visual correlation).
//
// Each output row carries only the fields the series that produced it had
// at that exact timestamp; fields from the other series are left undefined
// so Recharts renders a gap there rather than a fabricated/interpolated
// value. This is deliberately not a nearest-neighbor join - guessing which
// sample "belongs" to a timestamp from the other series would misrepresent
// data neither device actually reported at that instant.
export function mergeTimeSeries(series) {
  const rows = [];
  for (const { data, timestampKey = "timestamp", fields } of series) {
    for (const point of data || []) {
      const ts = point[timestampKey];
      if (!ts) continue;
      const timeNumeric = new Date(ts).getTime();
      if (Number.isNaN(timeNumeric)) continue;
      const row = { timeNumeric };
      for (const field of fields) row[field] = point[field];
      rows.push(row);
    }
  }
  rows.sort((a, b) => a.timeNumeric - b.timeNumeric);
  return rows;
}
